/** @format */

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { filter, map, switchMap } from 'rxjs/operators';
import { loadReviewAISummary, setReviewAISummary } from '../actions/product-reviews.actions';

import { ReviewService } from '../../service/review.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class ProductReviewsSummaryEffects {
    private readonly actions$ = inject(Actions);
    private readonly reviewService = inject(ReviewService);
    private readonly platformId = inject(PLATFORM_ID);

    loadReviewAISummary$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadReviewAISummary),
            filter(() => isPlatformBrowser(this.platformId)),
            switchMap(({ productId }) =>
                this.reviewService.getAIReviewSummary$(productId).pipe(
                    map((aiReview) => setReviewAISummary({ aiReview }))
                )
            )
        )
    );
}
